import CloseIcon from '../../../../public/assets/icons/close.svg';
import { StyledLink } from './styles';

type Props = {
	path: string;
};

export const BackLink = ({ path }: Props) => (
	<StyledLink href={path}>
		<CloseIcon />
	</StyledLink>
);
